import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import SegmentedPicker from '../controls/segmentedPicker';
import { hasPermission } from '../../../utils/paths';
import entityComposition from '../classes/entityComposition';
import MFAModal from './mfaModal';
import DisableModal from './disableModal';
const SecretSetup = ({
  customer,
  mfa,
  mfaActions,
  mfaEnabled: _mfaEnabled = false,
  mfaRequired: _mfaRequired = false,
  onlyModal: _onlyModal = false,
  onSuccess: _onSuccess = null,
  userID,
  username: _username = null
}) => {
  const [firstPin, setFirstPin] = useState('');
  const [secondPin, setSecondPin] = useState('');
  const toggleDisableModal = () => mfaActions.toggleModal('disable');
  const toggleMFAModal = () => mfaActions.toggleModal('mfa');
  const onChange = (pinName, pin) => {
    if (mfa.error) {
      mfaActions.clearError();
    }
    if (pinName === 'firstPin') {
      setFirstPin(pin);
    } else if (pinName === 'secondPin') {
      setSecondPin(pin);
    }
  };
  const onSecretSave = async () => {
    // this method tries to log the user in
    await mfaActions.serverSaveSecret(userID, firstPin, secondPin);
    if (_onSuccess) {
      _onSuccess(secondPin);
    }
    setFirstPin('');
    setSecondPin('');
  };
  const disableMFA = () => {
    mfaActions.serverDeleteSecret(userID);
  };
  const handleMFAToggleChange = newValue => {
    if (newValue) {
      toggleMFAModal();
    } else {
      toggleDisableModal();
    }
  };

  // Define all potential render pieces
  const isDisabled = _mfaRequired && !hasPermission('general', 'user_edit');
  const showDisableButton = !_mfaRequired && _mfaEnabled || hasPermission('general', 'user_edit') && _mfaEnabled;
  const modalProps = {
    createNewSecret: mfaActions.loadSecret,
    onClose: toggleMFAModal,
    showModal: mfa.modals.mfa,
    mfaEnabled: _mfaEnabled,
    username: _username,
    pins: {
      firstPin,
      secondPin
    },
    customer,
    onSave: onSecretSave,
    onChange,
    secret: mfa.secret,
    error: mfa.error
  };
  const disableModalProps = {
    showModal: mfa.modals.disable,
    onAction: disableMFA,
    onHide: toggleDisableModal
  };
  const generateNewSecretAndToggle = () => {
    mfaActions.loadSecret();
    toggleMFAModal();
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: _onlyModal ? 'none' : 'default'
    }
  }, /*#__PURE__*/React.createElement(DisableModal, disableModalProps), /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['Enabled', 'Disabled'],
    values: [1, 0],
    label: "Multifactor Authentication",
    allowNull: false,
    value: _mfaEnabled ? 1 : 0,
    onChange: handleMFAToggleChange,
    isDisabled: isDisabled
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    onClick: generateNewSecretAndToggle,
    className: "t-ss-generate-new tqc-control"
  }, "Generate New Secret For Authenticator"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, "Note: Successful creation of a new authentication secret will replace existing multi-factor authentication secret.")), /*#__PURE__*/React.createElement(MFAModal, modalProps), /*#__PURE__*/React.createElement("div", {
    style: {
      visibility: showDisableButton ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    className: "t-ss-disable tqc-control",
    onClick: toggleDisableModal
  }, "Disable MFA")));
};
SecretSetup.propTypes = {
  mfaActions: PropTypes.shape({
    toggleModal: PropTypes.func,
    serverDeleteSecret: PropTypes.func,
    loadSecret: PropTypes.func,
    serverSaveSecret: PropTypes.func,
    clearError: PropTypes.func
  }).isRequired,
  mfa: PropTypes.shape({
    error: PropTypes.string,
    authPin: PropTypes.string,
    modals: PropTypes.shape({
      disable: PropTypes.bool,
      mfa: PropTypes.bool
    }),
    secret: PropTypes.string
  }).isRequired,
  mfaEnabled: PropTypes.bool,
  mfaRequired: PropTypes.bool,
  username: PropTypes.string,
  userID: PropTypes.string.isRequired,
  customer: PropTypes.string.isRequired,
  onlyModal: PropTypes.bool,
  onSuccess: PropTypes.func
};
export { SecretSetup as TestSecretSetup };
export default entityComposition(SecretSetup, ['mfa'], {}, []);